import { FormikNetworkSelect } from '@/components/forms';

export default function NetworkSelector() {
  return <FormikNetworkSelect filterFn={(network) => !!network.canBeUsedForTokenHolders && !network.testnet} />;
}
